import React from 'react';

import { useIsMounted } from '@nfctron/nexus-react';

import { type OrgIntegratorConfigReturn, getOrgIntegratorConfig } from '../utils/orgIntegrators';

/**
 * Hook to manage org integrator configuration
 * @return {OrgIntegratorConfigReturn}
 */
export const useOrgIntegratorConfig = () => {
	const mounted = useIsMounted();

	return React.useMemo<OrgIntegratorConfigReturn>(() => {
		/** if server side, cannot match via hostname */
		if (!mounted) {
			return getOrgIntegratorConfig(null);
		}
		/** on client side, can match via hostname */
		return getOrgIntegratorConfig(window.location);
	}, [mounted]);
};
